

// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export namespace ResponseTypes {
	/**
	 * To improve build and incremental build times we transpile modules using TS transpileOnly mode. It essentially builds one file at a time
	 * Using transpileOnly with emitDecoratorMetadata flag sometimes causes issues when a type or an interface is used as a property type on a decorated property
	 * Example typescript:
	 * import {Models} from '../ags-generated';
	 * import AgsViewModel = Models.AgsViewModel;
	 * export class AgsStore {
	 *   @observable model: AgsViewModel;
	 * }
	 * Generated javascript:
	 * var ags_generated_1 = __webpack_require__(<webpackModuleId>);
	 * var AgsViewModel = ags_generated_1.Models.AgsViewModel;
	 * the previous line will result in runtime error if Models does not export anything
	 * In order to avoid runtime errors accessing undefined Models let's export dummy variable
	 */
	export const __dummy = true;
	export interface MobileNumber {
		Mobile: string;
		Country: Country;
		MobileCountryCodesSelectList: SelectListItem[];
		MobilePlaceholder: string;
		Note: string;
		ShowMobileIcon: boolean;
		IsRequired: boolean;
		IsReadOnly: boolean;
		CountryInfo: CountryInfo;
		HasNumber: boolean;
		IsConfirmationMessage: boolean;
	}
	export interface CountryInfo {
		CommonName: string;
		CCA2: string;
		ShortCodeForPushpay: string;
		CCN3: Country;
		CCA3: string;
		Currency: string;
		CallingCode: string;
		Capital: string;
		LatLong: Geolocation;
		SubRegions: SubRegion[];
		TimeZones: TimeZone[];
		MobilePlaceHolder: string;
		UseForCustomers: boolean;
		FlagIconClass: string;
		PostalCodeRegex: string;
		PostalCodeCommonName: string;
		IsEnabled: boolean;
	}
	export interface TimeZone {
		OlsonName: string;
		WindowsName: string;
	}
	export interface SubRegion {
		Code: string;
		Name: string;
	}
	export interface Geolocation {
		Latitude: number;
		Longitude: number;
	}
	export interface SelectListItem {
		Disabled: boolean;
		Group: SelectListGroup;
		Selected: boolean;
		Text: string;
		Value: string;
	}
	export interface SelectListGroup {
		Disabled: boolean;
		Name: string;
	}
	export enum Country {
		NZ = 0, AU = 1, US = 2, AF = 4, AL = 8, AQ = 10, DZ = 12, AS = 16, AD = 20, AO = 24, AG = 28, AZ = 31, AR = 32, AT = 40, BS = 44, BH = 48, BD = 50, AM = 51, BB = 52, BE = 56, BM = 60, BT = 64, BO = 68,
		BA = 70, BW = 72, BV = 74, BR = 76, BZ = 84, IO = 86, SB = 90, VG = 92, BN = 96, BG = 100, MM = 104, BI = 108, BY = 112, KH = 116, CM = 120, CA = 124, CV = 132, KY = 136, CF = 140, LK = 144, TD = 148, CL = 152,
		CN = 156, TW = 158, CX = 162, CC = 166, CO = 170, KM = 174, YT = 175, CG = 178, CD = 180, CK = 184, CR = 188, HR = 191, CU = 192, CY = 196, CZ = 203, BJ = 204, DK = 208, DM = 212, DO = 214, EC = 218, SV = 222,
		GQ = 226, ET = 231, ER = 232, EE = 233, FO = 234, FK = 238, GS = 239, FJ = 242, FI = 246, AX = 248, FR = 250, GF = 254, PF = 258, TF = 260, DJ = 262, GA = 266, GE = 268, GM = 270, PS = 275, DE = 276, GH = 288,
		GI = 292, KI = 296, GR = 300, GL = 304, GD = 308, GP = 312, GU = 316, GT = 320, GN = 324, GY = 328, HT = 332, HM = 334, VA = 336, HN = 340, HK = 344, HU = 348, IS = 352, IN = 356, ID = 360, IR = 364, IQ = 368,
		IE = 372, IL = 376, IT = 380, CI = 384, JM = 388, JP = 392, KZ = 398, JO = 400, KE = 404, KP = 408, KR = 410, KW = 414, KG = 417, LA = 418, LB = 422, LS = 426, LV = 428, LR = 430, LY = 434, LI = 438, LT = 440,
		LU = 442, MO = 446, MG = 450, MW = 454, MY = 458, MV = 462, ML = 466, MT = 470, MQ = 474, MR = 478, MU = 480, MX = 484, MC = 492, MN = 496, MD = 498, ME = 499, MS = 500, MA = 504, MZ = 508, OM = 512, NA = 516,
		NR = 520, NP = 524, NL = 528, CW = 531, AW = 533, SX = 534, BQ = 535, NC = 540, VU = 548, NI = 558, NE = 562, NG = 566, NU = 570, NF = 574, NO = 578, MP = 580, UM = 581, FM = 583, MH = 584, PW = 585, PK = 586,
		PA = 591, PG = 598, PY = 600, PE = 604, PH = 608, PN = 612, PL = 616, PT = 620, GW = 624, TL = 626, PR = 630, QA = 634, RE = 638, RO = 642, RU = 643, RW = 646, BL = 652, SH = 654, KN = 659, AI = 660, LC = 662,
		MF = 663, PM = 666, VC = 670, SM = 674, ST = 678, SA = 682, SN = 686, RS = 688, SC = 690, SL = 694, SG = 702, SK = 703, VN = 704, SI = 705, SO = 706, ZA = 710, ZW = 716, ES = 724, SS = 728, SD = 729, EH = 732,
		SR = 740, SJ = 744, SZ = 748, SE = 752, CH = 756, SY = 760, TJ = 762, TH = 764, TG = 768, TK = 772, TO = 776, TT = 780, AE = 784, TN = 788, TR = 792, TM = 795, TC = 796, TV = 798, UG = 800, UA = 804, MK = 807,
		EG = 818, GB = 826, GG = 831, JE = 832, IM = 833, TZ = 834, VI = 850, BF = 854, UY = 858, UZ = 860, VE = 862, WF = 876, WS = 882, YE = 887, ZM = 894, XK = 999, __ = -2, Unsupported = -1,
	}
	export interface ManageFundsViewModel {
		Listings: FundMerchantListingViewModel[];
		Funds: FundViewModel[];
		CanLoadMore: boolean;
		PagingCursor: string;
		LoadMoreUrl: string;
		PublishUrl: string;
		RedirectUrl: string;
		OrganizationId: number;
		UnsavedChangesExpiry: number;
		NewlyAddedFundKey: string;
		MaximumVisibleFundsPerListing: number;
		DefaultFundToggleTooltip: string;
		DisableAllListingsDropdownOption: boolean;
	}
	export interface FundViewModel {
		Key: string;
		Code: string;
		Name: string;
		EditUrl: string;
		IsNew: boolean;
		FundType: FundType;
		LinkedCampaignUrl: string;
	}
	export enum FundType {
		Unknown = 0, General = 1, Campaign = 2,
	}
	export interface FundMerchantListingViewModel {
		ListingName: string;
		ListingId: number;
		DefaultFundKey: string;
		Hash: string;
		FundKeys: string[];
	}
	export interface ManageFundsEditModel {
		Listings: ManageFundsEditModelListing[];
	}
	export interface ManageFundsEditModelListing {
		ListingId: number;
		DefaultFundKey: string;
		FundKeys: string[];
	}
	export interface FundListViewModel {
		InitialFunds: FundListItemViewModel[];
		TotalNumberOfListings: number;
		FundTotalsMessage: string;
		PollForUpdatedFundTotals: boolean;
		OrganizationHasUsedFunds: boolean;
		FundTotalsUrl: string;
	}
	export interface FundListItemViewModel {
		Key: string;
		Name: string;
		EditUrl: string;
		CanDeleteUrl: string;
		DeleteUrl: string;
		Notes: string;
		Code: string;
		DefaultOnNumberOfListings: number;
		ShownOnNumberOfListings: number;
		Total: number;
		IsOpen: boolean;
		IsUnknown: boolean;
		FundType: FundType;
		CampaignName: string;
		CampaignUrl: string;
	}
	export interface ReallocateTransactionsEditModel {
		PaymentIds: number[];
		FundKey: string;
		Query: TransactionsQueryModel;
		ReallocateAll: boolean;
	}
	export interface TransactionsQueryModel {
		FromDate: string;
		ToDate: string;
		PayerSearch: string;
		Page: number;
		Order: GridOrder;
		Source: PaymentSourceUi;
		State: TransactionQueryState;
		PaymentMethod: PaymentMethodTypeUi;
		Fund: string;
		UnvalidatedMerchantId: number;
		FilteredBySpecificTransactions: boolean;
	}
	export enum PaymentMethodTypeUi {
		Unknown = 0, CreditCard = 1, NzBankAccount = 2, ACH = 3, Cash = 4, Check = 5, AchAndAchCheck = 6, Other = 7,
	}
	export enum TransactionQueryState {
		SuccessfulOnly = 0, SuccessfulAndProcessing = 1, FailedOnly = 2,
	}
	export enum PaymentSourceUi {
		Mobile = 0, Web = 1, Recurring = 2, Kiosk = 3, VirtualTerminal = 4, TextGiving = 5, CheckDeposit = 6, TransactionImport = 7, BatchEntry = 8,
	}
	export enum GridOrder {
		Asc = 0, Desc = 1,
	}
	export interface FundValidationError {
		ErrorMessage: string;
	}
	export interface ValidationErrorModel {
		ValidationErrors: ValidationError[];
	}
	export interface ValidationError {
		ErrorMessage: string;
	}
	export interface FellowshipOneConfigurationViewModel {
		ViewModel: IntegrationViewModel;
		Listings: IntegrationListingConfigurationViewModel<FellowshipOneListingConfigurationModel>[];
		IntegrationFunds: IntegrationFundViewModel[];
		DefaultStatusForPeople: string;
		PeopleStatuses: SelectListItem[];
	}
	export interface IntegrationFundViewModel {
		Key: string;
		Code: string;
		Name: string;
		ParentFundKey: string;
	}
	export interface IIntegrationConfigurationViewModel<T> {
		ViewModel: IntegrationViewModel;
		Listings: IntegrationListingConfigurationViewModel<T>[];
	}
	export interface ListingMustHaveVisibleFundError {
		Listings: string[];
		MultipleListingsVisible: boolean;
		ManageFundsUrl: string;
		Verbage: string;
	}
	export interface IntegrationViewModel {
		Metadata: IIntegrationMetadata;
		IsNewConnection: boolean;
		SystemStatus: ExternalSystemStatus;
		IsAuthenticated: boolean;
		IsThirdParty: boolean;
		IsSetupIncomplete: boolean;
		Content: IntegrationContent;
		ActionUrls: ActionUrls;
		Warnings: IntegrationWarningCollection;
		FundsAreEnabled: boolean;
	}
	export interface IntegrationWarningCollection {
		WarningOnConfigureIntegration: IntegrationWarning;
		WarningOnImportFunds: IntegrationWarning;
	}
	export interface IntegrationWarning {
		Title: string;
		Message: string;
		CallsToAction: IntegrationCallToAction[];
	}
	export enum IntegrationCallToAction {
		ConnectIntegration = 0, ManageIntegration = 1, ImportFunds = 2, EnableIntegration = 3, ContactUs = 4,
	}
	export interface ActionUrls {
		EnableIntegrationUrl: string;
		DisableIntegrationUrl: string;
		DeleteIntegrationUrl: string;
		ConfigureIntegrationUrl: string;
		SetupAuthenticationUrl: string;
		CancelActionUrl: string;
		SaveFundsFileUrl: string;
		ConfigureIntegrationMappingsUrl: string;
		ImportFundsUrl: string;
		EnablePcoGivingUrl: string;
		DisablePcoGivingUrl: string;
	}
	export interface IntegrationContent {
		PrimaryLabels: IntegrationStatusLabel[];
		SecondaryLabels: IntegrationStatusLabel[];
		PrimaryStatusDescription: IHtmlString;
		SecondaryStatusDescription: IHtmlString;
		CallsToAction: IntegrationCallToAction[];
	}
	export interface IHtmlString {
	}
	export enum ExternalSystemStatus {
		Unknown = 0, Enabled = 1, Paused = 2, Disabled = 3, InSetup = 4, Deleted = 5,
	}
	export interface IIntegrationMetadata {
		IntegrationSystem: IIntegrationSystem;
		ProductName: string;
		ProductNameFirstUse: string;
		Logo: string;
		LegalDisclaimer: string;
		ManageUrl: string;
		HelpUrl: string;
		HelpUrlOld: string;
		InfoUrl: string;
		EnabledInCorePackage: boolean;
	}
	export interface IIntegrationSystem {
		SystemId: IntegrationSystemIdentifier;
		DisplayName: string;
		DisplayNameFirstUse: string;
		IsEnabled: boolean;
		HasConfiguration: boolean;
		IntegrationTypes: IntegrationTypes;
	}
	export interface IntegrationTypes {
		CommunityMemberIsEnabled: boolean;
		PersonIsEnabled: boolean;
		PaymentIsEnabled: boolean;
		SettlementIsEnabled: boolean;
		BatchIsEnabled: boolean;
		FundsAreEnabled: boolean;
		FundsRefreshIsEnabled: boolean;
	}
	export enum IntegrationSystemIdentifier {
		FellowshipOne = 0, ChurchCommunityBuilder = 1, Elvanto = 2, ThinkMinistry = 3, PlanningCenter = 4, QuickBooks = 5, ShelbyArena = 6,
	}
	export interface FellowshipOneListingConfigurationModel {
		FallbackFundKey: string;
	}
	export interface AddNewFundModel {
		ExternalSystemId: number;
		IntegrationFund: string;
		FundName: string;
		Code: string;
		TaxDeductible: boolean;
		Notes: string;
		IntegrationFundMatches: FundMatch[];
		QuickBooksIntegrationMapping: QuickBooksIntegrationMapping;
	}
	export interface QuickBooksIntegrationMapping {
		FundId: number;
		AccountId: string;
		ClassId: string;
		LocationId: string;
	}
	export interface FundMatch {
		IntegrationFundKey: string;
		ExternalSystemId: number;
	}
	export interface ImportFundMapping {
		IntegrationFundKey: string;
		PushpayFundKey: string;
	}
	export interface ImportFundMappings {
		FundMappings: ImportFundMapping[];
	}
	export interface ImportFundsViewModel {
		ExternalSystemId: number;
		IntegrationName: string;
		IntegrationFunds: ImportIntegrationFund[];
		FundMappings: ImportFundMappingViewModel[];
		FundCodePlaceholderText: string;
		PayerLabel: string;
		AddNewFundUrl: string;
		ImportUrl: string;
		Referrer: string;
		IntegrationViewModel: IntegrationViewModel;
		IntegrationFundsInfo: IntegrationFundsInfo[];
		QuickBooksManageFundInfo: QuickBooksManageFundInfo;
	}
	export interface QuickBooksManageFundInfo {
		DisplayName: string;
		DisplayNameFirstUse: string;
		CanLocationsBeConfigured: boolean;
		CanClassesBeConfigured: boolean;
		Configuration: QuickBooksExternalConfiguration;
		IntegrationMapping: QuickBooksIntegrationMapping;
	}
	export interface QuickBooksExternalConfiguration {
		Accounts: IntegrationFundViewModel[];
		Classes: IntegrationFundViewModel[];
		Locations: IntegrationFundViewModel[];
	}
	export interface IntegrationFundsInfo {
		DisplayName: string;
		ExternalSystemId: number;
		IntegrationFunds: IntegrationFundViewModel[];
	}
	export interface ImportFundMappingViewModel {
		PushpayFund: ImportPushpayFund;
		IntegrationFund: ImportIntegrationFund;
	}
	export interface ImportPushpayFund {
		Name: string;
		Code: string;
		Key: string;
		CloseFundUrl: string;
		IsLocked: boolean;
		Notes: string;
	}
	export interface ImportIntegrationFund {
		Name: string;
		Code: string;
		Key: string;
		TaxDeductible: boolean;
		ParentFundKey: string;
	}
	export interface FellowshipOneConfigurationEditModel {
		DefaultStatusForPeople: string;
		Listings: IntegrationListingConfigurationViewModel<FellowshipOneListingConfigurationModel>[];
	}
	export interface InsightsEnrollmentRecipients {
		Enrollments: InsightsEnrollmentViewModel[];
	}
	export interface InsightsEnrollmentViewModel {
		EmailAddress: string;
		EnrollmentState: InsightsEnrollmentRecipientState;
	}
	export enum InsightsEnrollmentRecipientState {
		Unknown = 0, Verified = 1, Unverified = 2, New = 3, Deleted = 4, Invalid = 5,
	}
	export interface RedirectRequest {
		RedirectTo: string;
	}
	export interface ElvantoListingConfigurationModel {
		FallbackFundKey: string;
	}
	export interface ElvantoConfigurationViewModel {
		ViewModel: IntegrationViewModel;
		Listings: IntegrationListingConfigurationViewModel<ElvantoListingConfigurationModel>[];
		IntegrationFunds: IntegrationFundViewModel[];
	}
	export interface CcbConfigurationViewModel {
		ViewModel: IntegrationViewModel;
		Listings: IntegrationListingConfigurationViewModel<CcbListingConfigurationModel>[];
		IntegrationFunds: IntegrationFundViewModel[];
		Campuses: CcbCampusViewModel[];
		AnonymousIndividualId: number;
		IsAnonymousFieldEnabled: boolean;
		IsMembershipTypeMappingEnabled: boolean;
		MembershipTypes: CcbMembershipTypeViewModel[];
		CommunityMemberTypes: CommunityMemberTypeViewModel[];
		DefaultCcbOrganizationalTypeId: number;
	}
	export interface CcbCampusViewModel {
		CampusId: number;
		CampusName: string;
	}
	export interface ElvantoAuthenticationEditModel {
		ClientId: string;
		SharedSecret: string;
	}
	export interface ElvantoConfigurationEditModel {
		Listings: IntegrationListingConfigurationViewModel<ElvantoListingConfigurationModel>[];
	}
	export interface CcbConfigurationEditModel {
		AnonymousIndividualId: number;
		Listings: IntegrationListingConfigurationViewModel<CcbListingConfigurationModel>[];
		MembershipTypeConfiguration: CcbMembershipTypeConfigurationEditModel;
	}
	export interface CcbAuthenticationEditModel {
		TenancyUrl: string;
		ApiUsername: string;
		ApiPassword: string;
	}
	export interface AutocompleteViewModel {
		Items: AutocompleteItem[];
		SelectedValue: string;
	}
	export interface AutocompleteItem {
		Text: string;
		TextPrefix: string;
		Value: string;
	}
	export interface MultiSelectViewModel {
		Items: MultiSelectItem[];
		SelectedValues: string[];
	}
	export interface MultiSelectItem {
		Text: string;
		SelectedText: string;
		Value: string;
		Disabled: boolean;
	}
	export interface FellowshipOneAuthenticationEditModel {
		ChurchCode: string;
	}
	export interface IntegrationListingConfigurationViewModel<T> {
		ListingId: number;
		ListingName: string;
		Model: T;
	}
	export interface IIntegrationConfigurationEditModel<T> {
		Listings: IntegrationListingConfigurationViewModel<T>[];
	}
	export interface ThinkMinistryListingConfigurationModel {
		FallbackFundKey: string;
	}
	export interface ThinkMinistryConfigurationViewModel {
		ViewModel: IntegrationViewModel;
		Listings: IntegrationListingConfigurationViewModel<ThinkMinistryListingConfigurationModel>[];
		IntegrationFunds: IntegrationFundViewModel[];
	}
	export interface ThinkMinistryConfigurationEditModel {
		Listings: IntegrationListingConfigurationViewModel<ThinkMinistryListingConfigurationModel>[];
	}
	export interface ThinkMinistryAuthenticationEditModel {
		InstanceUrl: string;
		ClientId: string;
		ClientSecret: string;
	}
	export interface CcbListingConfigurationModel {
		FallbackFundKey: string;
		CampusId: number;
	}
	export interface PlanningCenterListingConfigurationModel {
		FallbackFundKey: string;
		CampusId: string;
	}
	export interface PlanningCenterConfigurationViewModel {
		Message: FlashMessage;
		ViewModel: IntegrationViewModel;
		Listings: IntegrationListingConfigurationViewModel<PlanningCenterListingConfigurationModel>[];
		ShouldPromptToEnable: boolean;
		EnableIntegrationUri: string;
		CommunityMembersUrl: string;
		IntegrationsLandingPageUri: string;
		InstanceName: string;
		GivingStatus: GivingStatus;
		IsGivingModuleEnabled: boolean;
		PaymentSourceId: string;
		PaymentSources: PaymentSource[];
		IntegrationFunds: IntegrationFundViewModel[];
		IntegrationCampuses: PlanningCenterCampusViewModel[];
	}
	export interface PlanningCenterCampusViewModel {
		ExternalId: string;
		Name: string;
	}
	export interface PaymentSource {
		Id: string;
		Name: string;
	}
	export enum GivingStatus {
		Unknown = 0, NotConnected = 1, InSetup = 2, SetupComplete = 3, Enabled = 4, Disabled = 5,
	}
	export interface PlanningCenterAuthenticationEditModel {
	}
	export interface ShelbyArenaPaymentMethodEditModel {
		Name: string;
		IsEnabled: boolean;
		ShelbyArenaPaymentMethodId: number;
		Type: PaymentMethodType;
		Tooltip: string;
	}
	export enum PaymentMethodType {
		Unknown = 0, CreditCard = 1, NzBankAccount = 2, ACH = 3, Cash = 4, RecordedCheck = 5, AchCheck = 6, ProfitStarsScannedCheck = 7, RecordedCreditCard = 8, RecordedACH = 9, ImportedUnspecified = 10, ImportedUnsupported = 11,
	}
	export interface ShelbyArenaListingConfigurationModel {
		CampusId: number;
		FallbackFundKey: string;
	}
	export interface ShelbyArenaConfigurationViewModel {
		ViewModel: IntegrationViewModel;
		Listings: IntegrationListingConfigurationViewModel<ShelbyArenaListingConfigurationModel>[];
		IntegrationFunds: IntegrationFundViewModel[];
		AnonymousIndividualId: number;
		MembershipStatusId: number;
		MobilePhoneTypeId: number;
		PaymentMethods: ShelbyArenaPaymentMethodEditModel[];
		NonCashPaymentMethod: ShelbyArenaPaymentMethodEditModel;
		BatchPaymentsByPaymentMethods: boolean;
		DefaultPaymentMethodId: number;
		PayerLowerCaseLabel: string;
		FundsFileUploadVisibility: IntegrationFundsFileUploadVisibility;
	}
	export enum IntegrationFundsFileUploadVisibility {
		Unknown = 0, Visible = 1, Hidden = 2,
	}
	export interface ShelbyArenaConfigurationEditModel {
		Listings: IntegrationListingConfigurationViewModel<ShelbyArenaListingConfigurationModel>[];
		AnonymousIndividualId: number;
		MembershipStatusId: number;
		MobilePhoneTypeId: number;
		PaymentMethods: ShelbyArenaPaymentMethodEditModel[];
		NonCashPaymentMethod: ShelbyArenaPaymentMethodEditModel;
		BatchPaymentsByPaymentMethods: boolean;
		DefaultPaymentMethodId: number;
	}
	export interface ShelbyArenaAuthenticationEditModel {
		TenancyUrl: string;
		Username: string;
		Password: string;
		ApiKey: string;
		ApiSecret: string;
	}
	export interface ReallocateRecurringScheduleFundEditModel {
		ScheduleIds: number[];
		SourceFundKey: string;
		DestinationFundKey: string;
		Query: RecurringSchedulesQueryModel;
		ReallocateAll: boolean;
	}
	export interface RecurringSchedulesQueryModel {
		PayerSearch: string;
		UnvalidatedMerchantId: number;
		SourceForUi: PaymentSourceUi;
		Status: ScheduleStatusFilter;
		Fund: string;
	}
	export enum ScheduleStatusFilter {
		ActiveAndPaused = 1, Cancelled = 2, Completed = 3, All = 4,
	}
	export interface ReallocateRecurringScheduleFundError {
		ErrorMessages: string[];
	}
	export interface CommunityMemberTypeViewModel {
		CommunityMemberTypeId: number;
		CommunityMemberTypeName: string;
		IsOrganization: boolean;
	}
	export interface CcbMembershipTypeViewModel {
		MembershipTypeId: number;
		MembershipTypeName: string;
		MappedCommunityMemberType: CommunityMemberTypeViewModel;
	}
	export interface CcbMembershipTypeEditModel {
		MembershipTypeId: number;
		MappedCommunityMemberTypeId: CommunityMemberType;
	}
	export enum CommunityMemberType {
		Unknown = 0, Individual = 1, Organization = 2,
	}
	export interface CcbMembershipTypeConfigurationEditModel {
		MembershipTypeMappings: CcbMembershipTypeEditModel[];
		DefaultCcbOrganizationalTypeId: number;
	}
	export interface PlanningCenterConfigurationEditModel {
		PaymentSourceId: string;
		Listings: IntegrationListingConfigurationViewModel<PlanningCenterListingConfigurationModel>[];
	}
	export interface ManageFundsLoadMoreRequestModel {
		PagingCursor: string;
	}
	export interface IntegrationStatusLabel {
		CssClass: string;
		Label: string;
	}
	export interface FlashMessage {
		Title: string;
		Message: string;
		MessageType: FlashMessageType;
	}
	export enum FlashMessageType {
		Success = 0, Error = 1, Info = 2,
	}
	export interface MonitoredTaskStatus {
		TaskIdentifier: MonitoredTaskIdentifier;
		LastMessage: string;
		TotalItems: number;
		CurrentItems: number;
		TaskInfoType: string;
		TaskInfoJson: string;
		Status: string;
		LastUpdatedAt: string;
		CreatedAt: string;
		InProgress: boolean;
	}
	export interface MonitoredTaskIdentifier {
		Value: string;
	}
	export interface FundTotal {
		Key: string;
		Total: number;
	}
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export namespace ModelMetadata {
	export class MetadataArrayOf<T> {
		metadata: T;

		constructor(metadata: T) {
			this.metadata = metadata;
		}

		at(index: number): T {
			return this.metadata;
		}
	}

	export interface IPropertyMetadata {
		propertyName: string;
		displayName?: string;
		placeholder?: string;
		validationRules?: { [rule: string]: any };
		modelMetadata?: { [name: string] :IPropertyMetadata};
	}

	export let PlanningCenterConfigurationEditModel = {
		PaymentSourceId: {
			propertyName: "PaymentSourceId",
			displayName: "Default Payment Source",
			validationRules: {
				maxlength: {
					errorMessage: "The field Default Payment Source must be a string or array type with a maximum length of '20'.",
					parameters: {
						max: 20,
					},
				},
				required: {
					errorMessage: "The Default Payment Source field is required.",
				},
			},
		},
		Listings: {
			propertyName: "Listings",
		},
	};
	export let CcbMembershipTypeConfigurationEditModel = {
		MembershipTypeMappings: {
			propertyName: "MembershipTypeMappings",
			get modelMetadata() {
				return new MetadataArrayOf(ModelMetadata.CcbMembershipTypeEditModel);
			},
		},
		DefaultCcbOrganizationalTypeId: {
			propertyName: "DefaultCcbOrganizationalTypeId",
			displayName: "default organization",
			validationRules: {
				number: {
					errorMessage: "The field default organization must be a number.",
				},
				required: {
					errorMessage: "The default organization field is required.",
				},
			},
		},
	};
	export let CcbMembershipTypeEditModel = {
		MembershipTypeId: {
			propertyName: "MembershipTypeId",
			validationRules: {
				number: {
					errorMessage: "The field MembershipTypeId must be a number.",
				},
				required: {
					errorMessage: "The MembershipTypeId field is required.",
				},
			},
		},
		MappedCommunityMemberTypeId: {
			propertyName: "MappedCommunityMemberTypeId",
		},
	};
	export let ShelbyArenaAuthenticationEditModel = {
		TenancyUrl: {
			propertyName: "TenancyUrl",
			displayName: "Tenancy URL",
			placeholder: "https://[ Enter your instance URL ]/api.svc",
			validationRules: {
				maxlength: {
					errorMessage: "Tenancy URL has exceeded maximum length of '2000'.",
					parameters: {
						max: 2000,
					},
				},
				regex: {
					errorMessage: "Enter a valid URL beginning with https:// and ends with api.svc",
					parameters: {
						pattern: "^https://(.+)/api\\.svc$",
					},
				},
				required: {
					errorMessage: "Please enter your Shelby Arena tenancy URL",
				},
				skipsanitization: {},
			},
		},
		Username: {
			propertyName: "Username",
			displayName: "Username",
			validationRules: {
				maxlength: {
					errorMessage: "Username has exceeded maximum length of '200'.",
					parameters: {
						max: 200,
					},
				},
				required: {
					errorMessage: "Please enter your Username",
				},
				skipsanitization: {},
			},
		},
		Password: {
			propertyName: "Password",
			displayName: "Password",
			validationRules: {
				maxlength: {
					errorMessage: "Password has exceeded maximum length of '200'.",
					parameters: {
						max: 200,
					},
				},
				required: {
					errorMessage: "Please enter your Password",
				},
				skipsanitization: {},
			},
		},
		ApiKey: {
			propertyName: "ApiKey",
			displayName: "API key",
			validationRules: {
				maxlength: {
					errorMessage: "API key has exceeded maximum length of '50'.",
					parameters: {
						max: 50,
					},
				},
				required: {
					errorMessage: "Please enter your API key",
				},
				skipsanitization: {},
			},
		},
		ApiSecret: {
			propertyName: "ApiSecret",
			displayName: "API secret",
			validationRules: {
				maxlength: {
					errorMessage: "API secret has exceeded maximum length of '50'.",
					parameters: {
						max: 50,
					},
				},
				required: {
					errorMessage: "Please enter your API secret",
				},
				skipsanitization: {},
			},
		},
	};
	export let ShelbyArenaConfigurationEditModel = {
		Listings: {
			propertyName: "Listings",
		},
		AnonymousIndividualId: {
			propertyName: "AnonymousIndividualId",
			displayName: "Anonymous payer ID",
			validationRules: {
				number: {
					errorMessage: "The field Anonymous payer ID must be a number.",
				},
				regex: {
					errorMessage: "Please enter a valid anonymous payer ID",
					parameters: {
						pattern: "^[0-9]{0,9}$",
					},
				},
				required: {
					errorMessage: "The anonymous payer ID is required",
				},
				skipsanitization: {},
			},
		},
		MembershipStatusId: {
			propertyName: "MembershipStatusId",
			displayName: "Membership status ID",
			validationRules: {
				number: {
					errorMessage: "The field Membership status ID must be a number.",
				},
				regex: {
					errorMessage: "Please enter a valid membership status ID",
					parameters: {
						pattern: "^[0-9]{0,9}$",
					},
				},
				required: {
					errorMessage: "The membership status ID is required",
				},
				skipsanitization: {},
			},
		},
		MobilePhoneTypeId: {
			propertyName: "MobilePhoneTypeId",
			displayName: "Cell phone type ID",
			validationRules: {
				number: {
					errorMessage: "The field Cell phone type ID must be a number.",
				},
				regex: {
					errorMessage: "Please enter a valid cell phone type ID",
					parameters: {
						pattern: "^[0-9]{0,9}$",
					},
				},
				required: {
					errorMessage: "The cell phone type ID is required",
				},
				skipsanitization: {},
			},
		},
		PaymentMethods: {
			propertyName: "PaymentMethods",
			get modelMetadata() {
				return new MetadataArrayOf(ModelMetadata.ShelbyArenaPaymentMethodEditModel);
			},
		},
		NonCashPaymentMethod: {
			propertyName: "NonCashPaymentMethod",
			get modelMetadata() {
				return ModelMetadata.ShelbyArenaPaymentMethodEditModel;
			},
		},
		BatchPaymentsByPaymentMethods: {
			propertyName: "BatchPaymentsByPaymentMethods",
			validationRules: {
				required: {
					errorMessage: "The BatchPaymentsByPaymentMethods field is required.",
				},
			},
		},
		DefaultPaymentMethodId: {
			propertyName: "DefaultPaymentMethodId",
			displayName: "Default payment method ID",
			validationRules: {
				number: {
					errorMessage: "The field Default payment method ID must be a number.",
				},
				regex: {
					errorMessage: "Please enter a valid default payment method ID",
					parameters: {
						pattern: "^[0-9]{0,9}$",
					},
				},
				required: {
					errorMessage: "The default payment method ID is required",
				},
				skipsanitization: {},
			},
		},
	};
	export let ShelbyArenaConfigurationViewModel = {
		ViewModel: {
			propertyName: "ViewModel",
		},
		Listings: {
			propertyName: "Listings",
		},
		IntegrationFunds: {
			propertyName: "IntegrationFunds",
		},
		AnonymousIndividualId: {
			propertyName: "AnonymousIndividualId",
			validationRules: {
				number: {
					errorMessage: "The field AnonymousIndividualId must be a number.",
				},
			},
		},
		MembershipStatusId: {
			propertyName: "MembershipStatusId",
			validationRules: {
				number: {
					errorMessage: "The field MembershipStatusId must be a number.",
				},
			},
		},
		MobilePhoneTypeId: {
			propertyName: "MobilePhoneTypeId",
			validationRules: {
				number: {
					errorMessage: "The field MobilePhoneTypeId must be a number.",
				},
			},
		},
		PaymentMethods: {
			propertyName: "PaymentMethods",
			get modelMetadata() {
				return new MetadataArrayOf(ModelMetadata.ShelbyArenaPaymentMethodEditModel);
			},
		},
		NonCashPaymentMethod: {
			propertyName: "NonCashPaymentMethod",
			get modelMetadata() {
				return ModelMetadata.ShelbyArenaPaymentMethodEditModel;
			},
		},
		BatchPaymentsByPaymentMethods: {
			propertyName: "BatchPaymentsByPaymentMethods",
			validationRules: {
				required: {
					errorMessage: "The BatchPaymentsByPaymentMethods field is required.",
				},
			},
		},
		DefaultPaymentMethodId: {
			propertyName: "DefaultPaymentMethodId",
			validationRules: {
				number: {
					errorMessage: "The field DefaultPaymentMethodId must be a number.",
				},
			},
		},
		PayerLowerCaseLabel: {
			propertyName: "PayerLowerCaseLabel",
		},
		FundsFileUploadVisibility: {
			propertyName: "FundsFileUploadVisibility",
			validationRules: {
				required: {
					errorMessage: "The FundsFileUploadVisibility field is required.",
				},
			},
		},
	};
	export let ShelbyArenaListingConfigurationModel = {
		CampusId: {
			propertyName: "CampusId",
			displayName: "Campus ID",
			validationRules: {
				number: {
					errorMessage: "The field Campus ID must be a number.",
				},
				regex: {
					errorMessage: "Please enter a valid campus ID",
					parameters: {
						pattern: "^[0-9]{0,9}$",
					},
				},
				required: {
					errorMessage: "The campus ID is required",
				},
			},
		},
		FallbackFundKey: {
			propertyName: "FallbackFundKey",
			validationRules: {
				required: {
					errorMessage: "The fallback fund is required",
				},
				skipsanitization: {},
			},
		},
	};
	export let ShelbyArenaPaymentMethodEditModel = {
		Name: {
			propertyName: "Name",
		},
		IsEnabled: {
			propertyName: "IsEnabled",
			validationRules: {
				required: {
					errorMessage: "The IsEnabled field is required.",
				},
			},
		},
		ShelbyArenaPaymentMethodId: {
			propertyName: "ShelbyArenaPaymentMethodId",
			displayName: "Payment method ID",
			validationRules: {
				number: {
					errorMessage: "The field Payment method ID must be a number.",
				},
				regex: {
					errorMessage: "Please enter a valid payment method ID",
					parameters: {
						pattern: "^[0-9]{0,9}$",
					},
				},
				required: {
					errorMessage: "The payment method ID is required",
				},
			},
		},
		Type: {
			propertyName: "Type",
		},
		Tooltip: {
			propertyName: "Tooltip",
		},
	};
	export let PlanningCenterAuthenticationEditModel = {
	};
	export let PlanningCenterConfigurationViewModel = {
		Message: {
			propertyName: "Message",
		},
		ViewModel: {
			propertyName: "ViewModel",
		},
		Listings: {
			propertyName: "Listings",
		},
		ShouldPromptToEnable: {
			propertyName: "ShouldPromptToEnable",
			validationRules: {
				required: {
					errorMessage: "The ShouldPromptToEnable field is required.",
				},
			},
		},
		EnableIntegrationUri: {
			propertyName: "EnableIntegrationUri",
		},
		CommunityMembersUrl: {
			propertyName: "CommunityMembersUrl",
		},
		IntegrationsLandingPageUri: {
			propertyName: "IntegrationsLandingPageUri",
		},
		InstanceName: {
			propertyName: "InstanceName",
		},
		GivingStatus: {
			propertyName: "GivingStatus",
			displayName: "Giving Status",
			validationRules: {
				required: {
					errorMessage: "The Giving Status field is required.",
				},
			},
		},
		IsGivingModuleEnabled: {
			propertyName: "IsGivingModuleEnabled",
			validationRules: {
				required: {
					errorMessage: "The IsGivingModuleEnabled field is required.",
				},
			},
		},
		PaymentSourceId: {
			propertyName: "PaymentSourceId",
			displayName: "Default Payment Source",
		},
		PaymentSources: {
			propertyName: "PaymentSources",
		},
		IntegrationFunds: {
			propertyName: "IntegrationFunds",
		},
		IntegrationCampuses: {
			propertyName: "IntegrationCampuses",
		},
	};
	export let PlanningCenterListingConfigurationModel = {
		FallbackFundKey: {
			propertyName: "FallbackFundKey",
			validationRules: {
				required: {
					errorMessage: "Please select a default fund",
				},
			},
		},
		CampusId: {
			propertyName: "CampusId",
		},
	};
	export let CcbListingConfigurationModel = {
		FallbackFundKey: {
			propertyName: "FallbackFundKey",
			validationRules: {
				required: {
					errorMessage: "Please select a fallback fund",
				},
				skipsanitization: {},
			},
		},
		CampusId: {
			propertyName: "CampusId",
			displayName: "Campus",
			validationRules: {
				number: {
					errorMessage: "The field Campus must be a number.",
				},
			},
		},
	};
	export let ThinkMinistryAuthenticationEditModel = {
		InstanceUrl: {
			propertyName: "InstanceUrl",
			displayName: "Ministry Platform Instance URL",
			placeholder: "https://www.SomeUrl.org",
			validationRules: {
				httpurl: {
					errorMessage: "Please only use a https URL to connect to your Ministry Platform instance",
				},
				required: {
					errorMessage: "Please enter your instance URL",
				},
			},
		},
		ClientId: {
			propertyName: "ClientId",
			displayName: "Client ID",
			validationRules: {
				required: {
					errorMessage: "Please enter your client ID",
				},
				skipsanitization: {},
			},
		},
		ClientSecret: {
			propertyName: "ClientSecret",
			displayName: "Client secret",
			validationRules: {
				required: {
					errorMessage: "Please enter your client secret",
				},
				skipsanitization: {},
			},
		},
	};
	export let ThinkMinistryConfigurationEditModel = {
		Listings: {
			propertyName: "Listings",
		},
	};
	export let ThinkMinistryListingConfigurationModel = {
		FallbackFundKey: {
			propertyName: "FallbackFundKey",
			validationRules: {
				required: {
					errorMessage: "Please select a fallback fund",
				},
				skipsanitization: {},
			},
		},
	};
	export let IIntegrationConfigurationEditModel = {
		Listings: {
			propertyName: "Listings",
		},
	};
	export let IntegrationListingConfigurationViewModel = {
		ListingId: {
			propertyName: "ListingId",
			validationRules: {
				number: {
					errorMessage: "The field ListingId must be a number.",
				},
				required: {
					errorMessage: "The ListingId field is required.",
				},
			},
		},
		ListingName: {
			propertyName: "ListingName",
		},
		Model: {
			propertyName: "Model",
		},
	};
	export let FellowshipOneAuthenticationEditModel = {
		ChurchCode: {
			propertyName: "ChurchCode",
			displayName: "Church code",
			validationRules: {
				required: {
					errorMessage: "Please enter your church code",
				},
				skipsanitization: {},
			},
		},
	};
	export let CcbAuthenticationEditModel = {
		TenancyUrl: {
			propertyName: "TenancyUrl",
			displayName: "Tenancy Url",
			placeholder: "https://[ Enter your church ].ccbchurch.com/api.php",
			validationRules: {
				regex: {
					errorMessage: "Enter a valid Url beginning with https:// ending with ccbchurch.com/api.php",
					parameters: {
						pattern: "^https://[A-Za-z0-9](?:[A-Za-z0-9\\-_]{0,61}[A-Za-z0-9])?\\.ccbchurch\\.com/api\\.php$",
					},
				},
				required: {
					errorMessage: "Please enter your CCB tenancy Url",
				},
				skipsanitization: {},
			},
		},
		ApiUsername: {
			propertyName: "ApiUsername",
			displayName: "API username",
			validationRules: {
				required: {
					errorMessage: "Please enter your API username",
				},
				skipsanitization: {},
			},
		},
		ApiPassword: {
			propertyName: "ApiPassword",
			displayName: "API password",
			validationRules: {
				required: {
					errorMessage: "Please enter your API password",
				},
				skipsanitization: {},
			},
		},
	};
	export let CcbConfigurationEditModel = {
		AnonymousIndividualId: {
			propertyName: "AnonymousIndividualId",
			displayName: "Anonymous ID (optional)",
			validationRules: {
				number: {
					errorMessage: "The field Anonymous ID (optional) must be a number.",
				},
				regex: {
					errorMessage: "Please enter a CCB individual ID",
					parameters: {
						pattern: "^[0-9]{0,9}$",
					},
				},
				skipsanitization: {},
			},
		},
		Listings: {
			propertyName: "Listings",
		},
		MembershipTypeConfiguration: {
			propertyName: "MembershipTypeConfiguration",
			get modelMetadata() {
				return ModelMetadata.CcbMembershipTypeConfigurationEditModel;
			},
		},
	};
	export let ElvantoConfigurationEditModel = {
		Listings: {
			propertyName: "Listings",
		},
	};
	export let ElvantoAuthenticationEditModel = {
		ClientId: {
			propertyName: "ClientId",
			displayName: "Client ID",
			validationRules: {
				required: {
					errorMessage: "Please enter your client ID",
				},
				skipsanitization: {},
			},
		},
		SharedSecret: {
			propertyName: "SharedSecret",
			displayName: "Shared secret",
			validationRules: {
				required: {
					errorMessage: "Please enter your shared secret",
				},
				skipsanitization: {},
			},
		},
	};
	export let ElvantoListingConfigurationModel = {
		FallbackFundKey: {
			propertyName: "FallbackFundKey",
			validationRules: {
				required: {
					errorMessage: "Please select a fallback fund",
				},
				skipsanitization: {},
			},
		},
	};
	export let FellowshipOneConfigurationEditModel = {
		DefaultStatusForPeople: {
			propertyName: "DefaultStatusForPeople",
			displayName: "Default status of newly created people",
			validationRules: {
				required: {
					errorMessage: "Please select a default status",
				},
			},
		},
		Listings: {
			propertyName: "Listings",
		},
	};
	export let ImportFundMappings = {
		FundMappings: {
			propertyName: "FundMappings",
			validationRules: {
				required: {
					errorMessage: "The FundMappings field is required.",
				},
			},
			get modelMetadata() {
				return new MetadataArrayOf(ModelMetadata.ImportFundMapping);
			},
		},
	};
	export let ImportFundMapping = {
		IntegrationFundKey: {
			propertyName: "IntegrationFundKey",
			validationRules: {
				required: {
					errorMessage: "Select matching fund",
				},
				skipsanitization: {},
			},
		},
		PushpayFundKey: {
			propertyName: "PushpayFundKey",
			validationRules: {
				required: {
					errorMessage: "The PushpayFundKey field is required.",
				},
				skipsanitization: {},
			},
		},
	};
	export let AddNewFundModel = {
		ExternalSystemId: {
			propertyName: "ExternalSystemId",
			validationRules: {
				number: {
					errorMessage: "The field ExternalSystemId must be a number.",
				},
				required: {
					errorMessage: "The ExternalSystemId field is required.",
				},
			},
		},
		IntegrationFund: {
			propertyName: "IntegrationFund",
			validationRules: {
				required: {
					errorMessage: "Select matching fund",
				},
			},
		},
		FundName: {
			propertyName: "FundName",
			displayName: "Fund name",
			validationRules: {
				length: {
					errorMessage: "Please enter a fund name 50 characters or fewer",
					parameters: {
						max: 50,
					},
				},
				required: {
					errorMessage: "Please enter a fund name",
				},
			},
		},
		Code: {
			propertyName: "Code",
			displayName: "Code (optional)",
			validationRules: {
				length: {
					errorMessage: "Please enter a code 128 characters or fewer",
					parameters: {
						max: 128,
					},
				},
				skipsanitization: {},
			},
		},
		TaxDeductible: {
			propertyName: "TaxDeductible",
			displayName: "Tax deductible",
			validationRules: {
				required: {
					errorMessage: "Please choose whether the fund should be tax deductible or not",
				},
			},
		},
		Notes: {
			propertyName: "Notes",
			displayName: "Notes (optional)",
			validationRules: {
				length: {
					errorMessage: "Please enter notes 256 characters or fewer",
					parameters: {
						max: 256,
					},
				},
			},
		},
		IntegrationFundMatches: {
			propertyName: "IntegrationFundMatches",
		},
		QuickBooksIntegrationMapping: {
			propertyName: "QuickBooksIntegrationMapping",
			validationRules: {
				skipsanitization: {},
			},
		},
	};
	export let FellowshipOneListingConfigurationModel = {
		FallbackFundKey: {
			propertyName: "FallbackFundKey",
			validationRules: {
				required: {
					errorMessage: "Please select a fallback fund",
				},
				skipsanitization: {},
			},
		},
	};
	export let MobileNumber = {
		Mobile: {
			propertyName: "Mobile",
			displayName: "Mobile",
			validationRules: {
				regex: {
					errorMessage: "Please enter your mobile using just numbers",
					parameters: {
						pattern: "^\\+?[0-9-() ]*$",
					},
				},
				skipsanitization: {},
			},
		},
		Country: {
			propertyName: "Country",
			validationRules: {
				required: {
					errorMessage: "The Country field is required.",
				},
			},
		},
		MobileCountryCodesSelectList: {
			propertyName: "MobileCountryCodesSelectList",
		},
		MobilePlaceholder: {
			propertyName: "MobilePlaceholder",
		},
		Note: {
			propertyName: "Note",
		},
		ShowMobileIcon: {
			propertyName: "ShowMobileIcon",
			validationRules: {
				required: {
					errorMessage: "The ShowMobileIcon field is required.",
				},
			},
		},
		IsRequired: {
			propertyName: "IsRequired",
			validationRules: {
				required: {
					errorMessage: "The IsRequired field is required.",
				},
			},
		},
		IsReadOnly: {
			propertyName: "IsReadOnly",
			validationRules: {
				required: {
					errorMessage: "The IsReadOnly field is required.",
				},
			},
		},
		CountryInfo: {
			propertyName: "CountryInfo",
		},
		HasNumber: {
			propertyName: "HasNumber",
			validationRules: {
				required: {
					errorMessage: "The HasNumber field is required.",
				},
			},
		},
		IsConfirmationMessage: {
			propertyName: "IsConfirmationMessage",
			validationRules: {
				required: {
					errorMessage: "The IsConfirmationMessage field is required.",
				},
			},
		},
	};
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
